
export enum slbChunks {
    HEADER = 'slbHeader',
    FOOTER = 'slbFooter',
    COMMON = 'slbCommon',
    CART = 'slbCart',
    CLOUD_SOLUTIONS_PDP = 'slbCloudSolutionsPdp',
    EDGE_SOLUTIONS_PDP = 'slbEdgeSolutionsPdp',
    SERVICES_SOLUTIONS_PDP = 'slbServicesSolutionsPdp',
    OCEAN_SOLUTIONS_PDP = 'slbOceanSolutionsPdp',
    CHECKOUT = 'slbCheckout',
    ONLINE_PAYMENTS = 'SlbOnlinePayments'
}

export enum slbHeaderChunks {
    ACTIONS = 'actions'
}

export enum slbFooterChunks {
    FOOTER = 'footer'
}

export enum slbCartChunks {
    CART = 'cart',
    DELFI = 'delfi',
    MIXED = 'mixed',
    AGORA = 'agora',
    SERVICE = 'service',
    OCEAN = 'ocean',
    NEXT = 'next',
    SUBSCRIPTION = 'subscription',
    NOT_LISTED = 'notListed'
}

export enum slbCommonChunks {
    DOMAIN = 'domain',
    CASE_STUDIES = 'caseStudies',
    SLB = 'slb',
    SLB_PDP_DIVIDIED_BANNER = 'slbPdpDividedBanner',
    FORMS = 'forms',
    ADD_TO_CART_POP_UP = 'addToCartPopUp',
    FACET = 'facet',
    PLUGIN_FACET = 'pluginFacet',
    PAGINATION = 'pagination',
    AUTOCOMPLETE = 'autocomplete',
    PLATFORM_TYPE = 'platformType'
}

export enum slbCloudSolutionsPdpChunks {
    FORM = 'form',
    PRODUCT = 'product',
    CARD = 'card',
}

export enum slbCheckoutChunks {
    QUOTE = 'quote',
    SUMMARY = 'summary',
    DELFI_READINESS = 'delfiReadiness',
    SHIPPING = 'shipping',
    PAYMENT = 'payment',
    REVIEW = 'review',
    STORAGE = 'storage',
    READINESS = 'readiness',
    CONFIRMATION = 'confirmation',
    ORBITAL = 'orbital',
    LICENSE = 'license',
    ORDER = 'order'
}

export enum slbEdgeSolutionsPdpChunks {
    EDGE_SOLUTIONS_FORM = 'edgeSolutionsForm',
    EDGE_SOLUTIONS_CARD = 'edgeSolutionsCard',
    EDGE_SOLUTIONS_PAGE = 'edgeSolutionsPage',
}


export enum slbServicesSolutionsPdpChunks {
    SERVICES_PDP_ADD_TO_CART = 'servicesPdpAddToCart'
}

export enum slbOceanSolutionsPdpChunks {
    OCEAN_PDP_PRODUCT = 'oceanProduct'
}

export enum SlbOnlinePaymentsChunks {
    HISTORY = 'history',
    INVOICE = 'invoice',
    MAINTENANCE = 'maintenance'
}